export default __webpack_public_path__ + "static/media/skipcash-logo.f01a8783.png";